module.exports = __webpack_public_path__ + "img/64-5073cd.png";